import React, { useContext } from 'react';
import Button from '../../button/Button';
import { convertLegacyProps } from '../../button/buttonHelpers';
import { ModalContext } from '../context';
const NormalOkBtn = () => {
    const { confirmLoading, okButtonProps, okType, okTextLocale, onOk } = useContext(ModalContext);
    const onInternalClick = (event) => {
        onOk?.(event);
        okButtonProps?.onClick?.(event);
    };
    return (React.createElement(Button, { ...convertLegacyProps(okType), loading: confirmLoading, ...okButtonProps, onClick: onInternalClick }, okTextLocale));
};
export default NormalOkBtn;
